import { CheckCircle2 } from "lucide-react";
import { Chapter, Reveal } from "./shared";
import { AboutCarousel } from "./AboutCarousel";
import { useSiteConfig } from "@/context/SiteConfigContext";

const DEFAULT_PARAGRAPHS = [
  "A **Manutentudo** é especializada em Instalações, Manutenções e Reparos na rede de gás, com atendimento em **São Paulo e região**.",
  "Fundada em 2020 por **Vinicius Roberto**, profissional com mais de 10 anos de experiência na área, a empresa nasceu com um propósito claro: levar **segurança, praticidade e qualidade** para dentro da sua casa.",
  "Aqui, garantimos que cada detalhe seja feito com o **cuidado** e a **responsabilidade** que sua família merece. Se você precisa de um serviço confiável para sua rede de gás, conte com quem entende do assunto e realmente se importa com o cliente.",
  "Com a Manutentudo, você tem a **tranquilidade de estar em boas mãos**.",
];

const DEFAULT_POINTS = [
  "Atendimento humanizado e preço justo",
  "Materiais homologados e certificados",
  "Especialista gasista de ligação e conversão",
];

const rich = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") ? (
      <b key={i} className="text-zinc-900">
        {part.slice(2, -2)}
      </b>
    ) : (
      part
    )
  );

export const About = () => {
  const cfg = useSiteConfig();
  const paragraphs = cfg.about_paragraphs?.length ? cfg.about_paragraphs : DEFAULT_PARAGRAPHS;
  const points = cfg.about_points?.length ? cfg.about_points : DEFAULT_POINTS;

  return (
    <section id="sobre" className="bg-white pb-24 sm:pb-32" data-testid="about-section">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:px-8">
        <div>
          <Chapter
            num="05 — Quem somos"
            title={cfg.about_title || "Sobre a"}
            accent={cfg.about_accent || "Manutentudo Serviços"}
          />
          <Reveal className="-mt-8 space-y-4 text-base leading-relaxed text-zinc-600">
            {paragraphs.map((p, i) => (
              <p key={i}>{rich(p)}</p>
            ))}
          </Reveal>
          <Reveal delay={0.15} className="mt-6 space-y-3">
            {points.map((p) => (
              <div key={p} className="flex items-center gap-2.5 text-sm font-medium text-zinc-800">
                <CheckCircle2 size={17} className="shrink-0 text-[var(--primary)]" />
                {p}
              </div>
            ))}
          </Reveal>
        </div>
        <Reveal delay={0.1} className="relative pb-8">
          <AboutCarousel />
        </Reveal>
      </div>
    </section>
  );
};
